import { render, staticRenderFns } from "./HubPageEditorDialog.vue?vue&type=template&id=386592b6&"
import script from "./HubPageEditorDialog.vue?vue&type=script&lang=js&"
export * from "./HubPageEditorDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports